import { type Common } from '../common.js';
import { type FileReferenceData, type FileReferenceUrl } from '../models/flow/file.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/data-access/files';

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(fileReference: string): Promise<FileReferenceData> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${encodeURIComponent(fileReference)}`
    );
    return await this.common.getJSON(url);
  }

  async generateReadUrl(
    fileReference: string,
    options?: {
      preferPdf?: boolean;
    }
  ): Promise<FileReferenceUrl> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${encodeURIComponent(fileReference)}/generate-read-url`,
      options
    );

    return await this.common.postJSON(url, {});
  }
}
